<template>
    <div class="welcome-message">
        <div class="welcome-message-content">
            <h1 class="title">Hi～我是病虫害捕手</h1>
            <p class="subtitle">病虫害捕手是基于神农大模型研发的作物病虫害识别</p>
            <p class="description">
                病虫害捕手是基于神农大模型研发的作物病虫害识别，用户可以上传作物图片并描述问题，让AI帮您诊断作物疾病，当前支持番茄、黄瓜、辣椒等75种农作物的615种常见病虫害准确识别。</p>

            <div class="question-hints">
                <p class="hint-title">您可以这样问...</p>
                <div class="hint-items" v-for="item in hintItems" :key="item.id" @click="handleHintClick(item.title)">
                    <div class="hint-item">{{ item.title }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// 组件逻辑
export default {
    data() {
        return {
            hintItems: [
                { id: 1, title: '水稻稻飞虱的防治方法有哪些？' },
                { id: 2, title: '小麦白粉病的发生条件和防治措施是什么？' },
                { id: 3, title: '如何绿色防控苹果园的蚜虫？' }
            ]
        }
    },
    methods: {
        handleHintClick(title) {
            // 触发自定义事件并传递标题
            this.$emit('hint-selected', title);
        }
    }
}
</script>

<style scoped>
/* 欢迎页样式 */
.welcome-message {
    width: 100%;
    margin: 180px 0 0 0;
    display: flex;
    justify-content: center;
}

.welcome-message-content {
    width: 879px;
    text-align: center;
}

.title {
    width: 440px;
    height: 50px;
    font-family: FZLTTHK--GBK1, FZLTTHK--GBK1;
    font-weight: bold;
    font-size: 36px;
    color: #303030;
    line-height: 50px;
    margin-bottom: 9px;
}

.subtitle {
    width: 520px;
    height: 28px;
    font-weight: 600;
    font-size: 20px;
    color: #6A6A6A;
    line-height: 28px;
    margin-bottom: 10px;
}

.description {
    width: 613px;
    height: 66px;
    font-weight: 400;
    font-size: 16px;
    color: #888888;
    line-height: 22px;
    text-align: left;
    font-style: normal;
}

.question-hints {
    margin-top: 30px;
    text-align: left;
}

.hint-title {
    width: 112px;
    height: 22px;
    font-weight: 400;
    font-size: 16px;
    color: #A0A0A0;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    margin-bottom: 18px;
    margin-top: 30px;
}

.hint-items {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
}

.hint-item {
    background: #F3F3F3;
    border-radius: 10px;
    padding: 12px 20px;
    color: #333;
    max-width: 80%;
    cursor: pointer;
    transition: background-color 0.2s;
    margin-bottom: 10px;


    font-weight: 400;
    font-size: 16px;
    color: #303030;
    line-height: 22px;
    font-style: normal;
}

.hint-item:hover {
    background-color: #e6e6e6;
}

@media (max-width: 768px) {
    .welcome-message-content {
        max-width: 95%;
        padding: 20px;
    }

    .title {
        font-size: 24px;
    }

    .subtitle {
        font-size: 16px;
    }

    .hint-item {
        max-width: 95%;
    }
}
</style>